import { render, staticRenderFns } from "./RekapTukarPromoMerchant.vue?vue&type=template&id=5e452957"
import script from "./RekapTukarPromoMerchant.vue?vue&type=script&lang=js"
export * from "./RekapTukarPromoMerchant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports